import { mapGetters } from 'vuex';
import SelectBank from '@/components/select-bank/index.vue';
import SelectAgent from '@/components/select-agent/index.vue';
import { validateDate, getAfficheTextByType } from '@/utils/common.js';
import Service from '@/service/index.js';
import moment from 'moment';
export default {
  components: {
    SelectBank,
    SelectAgent
  },
  props: ['projectInfo'],
  data() {
    const validateTenderEndTime = (rule, value, callback) => {
      let date = new Date(new Date().getTime() - 24*60*60*1000);
      if(value && validateDate(date, value)) {
        callback(new Error('只能选择今天及以后的时间'));
      } else if (!this.tenderEndTime2) {
        callback(new Error('请选择时分秒'));
      } else {
        callback();
      }
    };
    const validateTenderOpenTime = (rule, value, callback) => {
      let date = new Date(new Date().getTime() - 24*60*60*1000);
      if(value && validateDate(date, value)) {
        callback(new Error('只能选择今天及以后的时间'));
      } else if (!this.tenderOpenTime2) {
        callback(new Error('请选择时分秒'));
      } else {
        callback();
      }
    };
    const validateNoticeDays = (rule, value, callback) => {
      let days = 5;
      if (this.purchaseType === 5) {
        days = 20;
      }
      if (Number(value) > 360 || Number(value) < days) {
        callback(new Error(`公告时间须在${days}-360之内`));
      } else {
        callback();
      }
    };
    return {
      acceptJointBiddingArr: [],
      ruleForm: {
        constructionScale: '',
        qualityStandard: '符合现行国家、行业及地方工程施工质量验收标准以及相关专业验收规范的合格标准。',
        purchaseScope: '施工图纸及工程量清单所包含的全部内容。',
        paymentWay: '',
        bidDivision: '本项目不划分标段。',
        other: '具体情况详见采购文件。',
        bankId: '',
        noticeDays: '5',
        bidAgentOrgId: '', // 招标代理机构Id
        acceptJointBidding: '',  // 是否接受联合投标
        tenderEndTime: '',  // 递交投标文件的截止时间
        tenderAddress: '',  // 递交投标文件的地点
        tenderOpenTime: '', // 投标截止时间及开标时间
        tenderOpenAddress: '' // 开标地点
      },
      tenderEndTime2: '',
      tenderOpenTime2: '',
      rules: {
        constructionScale: [
          { required: true, message: '请输入建设规模', trigger: 'blur' }
        ],
        qualityStandard: [
          { required: true, message: '请输入质量标准', trigger: 'blur' }
        ],
        purchaseScope: [
          { required: true, message: '请输入采购范围', trigger: 'blur' }
        ],
        paymentWay: [
          { required: true, message: '请输入付款方式', trigger: 'blur' }
        ],
        bidDivision: [
          { required: true, message: '请输入标段划分', trigger: 'blur' }
        ],
        bankId: [
          { required: true, message: '请选择银行账号', trigger: 'blur' }
        ],
        noticeDays: [
          { required: true, message: '请输入公告时间', trigger: 'blur' },
          { required: true, validator: validateNoticeDays, trigger: 'blur' }
        ],
        bidAgentOrgId: [
          { required: true, message: '请选择招标代理机构', trigger: 'blur' }
        ],
        acceptJointBidding: [
          { required: true, message: '请选择是否接受联合投标', trigger: 'change' }
        ],
        tenderEndTime: [
          { required: true, message: '请选择递交投标文件的截止时间', trigger: 'blur' },
          { required: true, validator: validateTenderEndTime, trigger: 'change' }
        ],
        tenderAddress: [
          { required: true, message: '请输入递交投标文件的地点', trigger: 'blur' }
        ],
        tenderOpenTime: [
          { required: true, message: '请选择投标截止时间及开标时间', trigger: 'blur' },
          { required: true, validator: validateTenderOpenTime, trigger: 'change' }
        ],
        tenderOpenAddress: [
          { required: true, message: '请输入开标地点', trigger: 'blur' }
        ]
      }
    };
  },
  created () {
    this.getDictionarySelect();
  },
  watch: {
    projectTypeOfPur () {
      console.log(this.projectTypeOfPur, typeof this.projectTypeOfPur, '=-==========projectTypeOfPur');
      this.$refs['explainForm'].resetFields();
      if (Number(this.projectTypeOfPur) !== 1) {
        this.ruleForm.purchaseScope = '';
        this.ruleForm.bidDivision = '';
        this.ruleForm.paymentWay = '验收合格后，一次性支付（开具增值税普通发票）。';
        this.ruleForm.qualityStandard = '';
        this.$set(this.rules.constructionScale, 0,  { required: true, message: '请输入采购内容', trigger: 'blur' });
        this.$set(this.rules.purchaseScope, 0,  { required: true, message: '请输入质保期', trigger: 'blur' });
        // this.$set(this.rules.purchaseScope, 0,  { });
        // this.$set(this.rules.paymentWay, 0,  { required: true, message: '请输入付款方式', trigger: 'blur' });
      } else {
        this.ruleForm.purchaseScope = '施工图纸及工程量清单所包含的全部内容。';
        this.ruleForm.bidDivision = '本项目不划分标段。';
        this.ruleForm.qualityStandard = '符合现行国家、行业及地方工程施工质量验收标准以及相关专业验收规范的合格标准。';
        this.ruleForm.paymentWay = '';
        this.$set(this.rules.constructionScale, 0,  { required: true, message: '请输入建设规模', trigger: 'blur' });
        this.$set(this.rules.purchaseScope, 0,  { required: true, message: '请输入采购范围', trigger: 'blur' });
        this.$set(this.rules.bidDivision, 0,  { required: true, message: '请输入标段划分', trigger: 'blur' });
      }
    },
    projectInfo () {
      Object.keys(this.ruleForm).forEach((key) => {
        if (this.projectInfo[key]) {
          this.ruleForm[key] = this.projectInfo[key];
          if (key === 'acceptJointBidding') {
            this.ruleForm[key] = String(this.projectInfo[key]);
          } else if (key === 'tenderEndTime' || key === 'tenderOpenTime') {
            let hours = moment(this.projectInfo[key]).hours();
            hours = hours < 10 ?  `0${hours}:00:00` : hours + ':00:00';

            console.log(hours, '======ssssss');

            if (key === 'tenderEndTime') {
              this.tenderEndTime2 = hours;
            } else {
              this.tenderOpenTime2 = hours;
            }
          }
        }
      });
    },
    purchaseType (value) {
      value = Number(value);
      if ([4, 5].includes(value)) {
        this.ruleForm = {
          ...this.ruleForm,
          qualityStandard: '',
          purchaseScope: '',
          bidDivision: '',
          other: ''
        };
      } else {
        this.ruleForm = {
          ...this.ruleForm,
          qualityStandard: '符合现行国家、行业及地方工程施工质量验收标准以及相关专业验收规范的合格标准。',
          purchaseScope: '施工图纸及工程量清单所包含的全部内容。',
          bidDivision: '本项目不划分标段。',
          other: '具体情况详见采购文件。'
        };
      }
      // 一般招标和一次报价方式 5天  依法必招20天
      if (value === 5) {
        this.ruleForm.noticeDays = 20;
      } else {
        this.ruleForm.noticeDays = 5;
      }
    },
    'ruleForm.tenderEndTime' (value) {
      if(value) {
        this.ruleForm.tenderOpenTime = value;
      } else {
        this.ruleForm.tenderOpenTime = '';
      }
    }
  },
  computed: {
    ...mapGetters([
      'projectTypeOfPur',
      'purchaseType'
    ]),
    afficheTime() {
      return getAfficheTextByType(this.purchaseType);
    }
  },
  methods: {
    tenderEndTime2Change(value) {
      this.tenderOpenTime2 = value;
    },
    getAgentInfo (info) {
      this.ruleForm.tenderAddress = info.bidAgentOrgAddress;
      this.ruleForm.tenderOpenAddress = info.bidAgentOrgAddress;
    },
    // 获取字典项
    getDictionarySelect() {
      Service.getSelectList('ACCEPT_JOINT_BIDDING').then(({ code, data }) => {
        if (code === '0') {
          this.acceptJointBiddingArr = data;
        }
      });
    },
    test() {
      return new Promise((resolve, reject) => {
        this.$refs['explainForm'].validate((valid) => {
          if (valid) {
            this.ruleForm = {
              ...this.ruleForm,
              tenderEndTime: this.ruleForm.tenderEndTime + ' ' + this.tenderEndTime2,
              tenderOpenTime: this.ruleForm.tenderOpenTime + ' ' + this.tenderOpenTime2
            },
            resolve(JSON.parse(JSON.stringify(this.ruleForm)));
          } else {
            reject();
          }
        });
      });
    }
  }
};
